import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Form, InputGroup } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/pro-solid-svg-icons';
import PageLibraryRow from './page_library_row';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export function PageLibrary({
  addDefaultPage,
  availablePages,
  locked,
  pages,
  removeLibraryPage,
  onReorderPage,
  templateDefaultPageLibrary
}) {
  const [searchText, setSearchText] = useState('');

  let templatesForDisplay = locked ? templateDefaultPageLibrary : (pages || []);
  if (searchText.length > 0) {
    if (templatesForDisplay[0].name === undefined) {
      const pageIds = availablePages.filter(({ name }) => name.match(new RegExp(searchText, 'gi'))).map(({ id }) => id);
      templatesForDisplay = templatesForDisplay.filter(({ id }) => pageIds.includes(id));
    } else {
      templatesForDisplay = templatesForDisplay.filter(({ name }) => name.match(new RegExp(searchText, 'gi')));
    }
  }

  return (
    <div className="mb-4">
      <div className="my-3">
        <strong className="fw-semibold">Page Library</strong>
      </div>
      <p className="my-3">
        The pages that will populate into the "Page Library" section of the document editor
      </p>
      <Form.Group className="mb-3">
        <InputGroup>
          <InputGroup.Text className="text-primary">
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search"
            type="text"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
          />
          <button
            aria-label="Clear search"
            className="btn btn-outline-secondary"
            disabled={!searchText}
            type="button"
            onClick={() => setSearchText('')}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </InputGroup>
      </Form.Group>
      {templatesForDisplay.length === 0 && (
        <div className="text-muted py-4 text-center">No results</div>
      )}
      {templatesForDisplay.length !== 0 && (
        <Card className="overflow-auto" style={{ maxHeight: '300px' }}>
          <ul className="list-group list-group-flush">
            {templatesForDisplay.map((page, index) => {
              const foundPage = availablePages.find(availablePage => availablePage.id === page.id);
              if (foundPage) {
                return (
                  <PageLibraryRow
                    addDefaultPage={addDefaultPage}
                    index={index}
                    key={page.key || page.id}
                    locked={locked}
                    page={foundPage}
                    removeLibraryPage={removeLibraryPage}
                    onReorder={onReorderPage}
                  />
                );
              }
            })}
          </ul>
        </Card>
      )}
    </div>
  );
}

PageLibrary.propTypes = {
  addDefaultPage: PropTypes.func.isRequired,
  availablePages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  locked: PropTypes.bool.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired
  })),
  removeLibraryPage: PropTypes.func.isRequired,
  templateDefaultPageLibrary: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  onReorderPage: PropTypes.func.isRequired
};

export default reorderableList(PageLibrary);
